
export const COUNTRIES = [
    "United States",
    "United Kingdom",
    "Canada",
    "Australia",
    "Germany",
    "India",
    "France",
    "Italy",
    "Spain",
    "Netherlands",
    "Brazil",
    "Poland",
    "Ukraine",
    "Russia",
    "China",
    "Japan",
    "Philippines",
    "Pakistan",
    "Bangladesh",
    "Vietnam",
    "Mexico",
    "Argentina",
    "Sweden",
    "Switzerland",
    "Belgium",
    "Austria",
    "Norway",
    "Denmark",
    "Ireland",
    "New Zealand",
    "Singapore",
    "United Arab Emirates",
    "Turkey",
    "Egypt",
    "Indonesia",
    "Malaysia",
    "Thailand",
    "South Africa",
    "Portugal",
    "Greece",
    "Czech Republic",
    "Hungary",
    "Romania",
    "Israel",
    "South Korea",
    "Finland",
    "Colombia",
    "Chile",
    "Saudi Arabia",
    "Bulgaria",
    "Serbia",
    "Slovakia",
    "Croatia",
    "Estonia",
    "Latvia",
    "Lithuania",
    "Slovenia",
    "Belarus",
    "Kazakhstan",
    "Armenia",
    "Georgia",
    "Moldova",
    "Morocco",
    "Tunisia",
    "Algeria",
    "Nigeria",
    "Kenya",
    "Ghana",
    "Sri Lanka",
    "Nepal"
];
